import { chargingAmountWarning } from "./charginghistory";

export const flowHeader = "Übersicht";
export const flowHeaderApp = "Energie";

export const flowTexts = [
  {
    type: "text",
    content:
      "Auf der Startseite werden die aktuellen Energieflüsse Ihrer Anlage " +
      "gezeigt. Diese umfassen folgende Daten (bei Vorhandensein entsprechender Komponenten): ",
  },
  {
    type: "enumeration",
    content: [
      "Die Produktion Ihrer PV-Anlage",
      "Das Entladen / Laden der Batterie (sowie den Batterieladezustand)",
      "Den Netzbezug / die Einspeisung",
      "Den Bezug Ihrer Wallbox",
      "Die Last Ihres Haushaltes",
    ],
  },
  { type: "space" },
  // {
  //   type: "text",
  //   content:
  //     "Dieser Graph wird regelmäßig aktualisiert und zeigt den Ist-Zustand an. Ist ein Energieimpuls an all Ihre " +
  //     "Geräten angeschlossen, werden die Daten in kurzen Zeitabständen ausgelesen und hier angezeigt. " +
  //     "Sind nicht all Ihre Geräte, wie bspw. ein zweiter Wechselrichter, an Ihren Energieimpuls angeschlossen " +
  //     "und werden stattdessen zusätzlich Daten vom Service des Herstellers genutzt, werden diese in deutlich geringerer zeitlicher " +
  //     "Auflösung aktualisiert. Durch die unterschiedliche Auflösung der Daten, kann es hier zeitweise zu konträren Zuständen kommen. Diese behindern " +
  //     "jedoch nicht die Steuerung Ihrer Komponenten durch den Energieimpuls, wie bspw. die Überschussladung, da diese " +
  //     "über die Einspeisung gesteuert wird, die vom Energieimpuls ausgelesen wird.",
  //   condition: (context) => context?.location?.impulsclient_set?.length > 0,
  // },
];

export const wallboxFlowTexts = [
  {
    type: "subtitle",
    content: "Wallbox-Steuerung",
  },
  {
    type: "text",
    content: "Unten auf der Startseite kann Ihre Wallbox gesteuert werden:",
  },
  { type: "space" },
  {
    type: "subsubtitle",
    content: "Sperren/Entsperren:",
  },
  {
    type: "text",
    content:
      "Wenn Sie auf das Schloss-Symbol klicken, können Sie Ihre Wallbox sperren/entsperren. Sie können die Wallbox " +
      "dauerhaft entsperrt lassen (z. B. wenn diese sich in Ihrer Garage befindet) oder nach dem Ladevorgang " +
      "sperren, um zu verhindern, dass Unbefugte Ihre Wallbox nutzen.",
  },
  { type: "space" },
  {
    type: "subsubtitle",
    content: "PV-Überschussladen:",
  },
  {
    type: "text",
    content:
      "Wenn Sie wünschen, dass Ihr E-Fahrzeug nur mit Strom aus Ihrer PV-Anlage geladen wird, aktivieren Sie das " +
      "„PV-Überschussladen“. Beim PV-Überschussladen wird Ihre Wallbox das E-Fahrzeug nur laden, wenn Ihre PV-Anlage " +
      "mehr Strom produziert als Sie verbrauchen. Dies ermöglicht eine optimale Nutzung Ihrer Energie, da Sie " +
      "lediglich Ihr Auto laden, wenn Ihre PV-Anlage Strom produziert und so das Laden mit vergleichsweise teurem " +
      "Netzstrom verhindert wird. Die Wallbox beginnt das Auto zu laden, sobald Ihr Überschuss die minimale " +
      "Ladeenergie der Wallbox übersteigt. Die Ladeenergie wird fortlaufend an Ihren Überschuss angepasst.",
  },
  { type: "space" },
  {
    type: "subsubtitle",
    content: "PV-Hybridladen:",
  },
  {
    type: "text",
    content:
      "Wenn Sie wünschen, dass Ihr E-Fahrzeug im hybriden Modus mit der Mindestleistung aus dem Netz bzw. der " +
      "Batterie und zusätzlichem PV-Überschuss geladen wird, aktivieren Sie das PV-Hybridladen. Die Wallbox beginnt " +
      "sofort, das Auto zu laden, auch wenn der PV-Überschuss die Mindestleistung nicht erreicht. Die zusätzliche " +
      "Ladeenergie, die nicht auch dem Netz oder der Batterie kommt, wird fortlaufend an Ihren Überschuss angepasst. " +
      "Sie können hierbei den Ladestrom zwischen 6A und 16A einstellen. Die Wallbox zieht dann immer den " +
      "PV-Überschuss der Anlage und ergänzt dann mit Netz- bzw. Batteriestrom, um den eingestellten Ladestrom zu " +
      "erreichen.",
  },
];

export const heatpumpFlowTexts = [
  {
    type: "subtitle",
    content: "Wärmepumpen-Steuerung",
  },
  {
    type: "text",
    content:
      "Ihre Wärmepumpe ist SG-Ready-fähig. Dies bedeutet, dass die Soll-Temperatur erhöht werden kann, wenn viel " +
      "Sonnenenergie verfügbar ist. Zur Schonung Ihrer Wärmepumpe sollte dies jedoch nicht beliebig oft erfolgen. " +
      "Die Steuerung der Wärmepumpe übernimmt das System für Sie basierend auf Wetter- und Lastvorhersagen. Daher " +
      "sehen Sie hier lediglich den Status, können Ihn aber nicht manuell ändern. Bitte beachten Sie, dass es ein " +
      "paar Tage dauern kann, bis die Soll-Temperatur der Wärmepumpe das erste Mal bei hoher PV-Erzeugung erhöht " +
      "wird, da zunächst ein Kalibiervorgang für die Schätzung der Verbrauchswerte läuft. Zudem können hier die " +
      "Zeiten eingeschränkt werden, in denen SG-Ready eingeschaltet wird, falls Sie dies wünschen. Stellen Sie " +
      "bspw. die früheste Anschaltzeit auf 9 Uhr und die späteste Anschaltzeit auf 18 Uhr, wird SG-Ready nicht " +
      "vor 9 bzw. nach 18 Uhr eingeschaltet. Beachten Sie hier, dass es sich lediglich um eine Einschränkung der " +
      "Einschaltzeiten handelt. Wird SG-Ready um 17 Uhr eingeschaltet, kann es (bei entsprechender Erzeugungs- und " +
      "Verbrauchsprognose) sein, dass es bis 19 Uhr eingeschaltet bleibt.",
  },
  {
    type: "text",
    content:
      "Zudem kann der minimale Ladezustand der Batterie eingestellt werden. Dieser schränkt die Anschaltzeit " +
      "dahingehend ein, dass die Batterie mindestens den angegebenen Ladezustand aufweisen muss, damit SG-Ready " +
      "eingeschaltet wird. Beachten Sie hier, dass es sich lediglich um die Einschränkung der Einschaltung handelt. " +
      "Unterschreitet die Batterie den angegeben Ladezustand, wird SG-Ready nicht ausgeschaltet.",
    condition: (context) =>
      context?.location?.inverter_set?.some((i) => i.battery_capacity),
  },
];

export const flowHistoryHeader = "Flusshistorie";

export const flowHistoryTexts = [
  {
    type: "text",
    content:
      "In der Flusshistorie sehen Sie vergangene Energieflüsse (Tages- / Monats- und Jahresdaten). Die Tagesansicht " +
      "zeigt die Werte aufgeschlüsselt im 5-Minuten-Takt über den Tag. Hierbei handelt es sich um Momentaufnahmen " +
      "zu der jeweiligen Uhrzeit und nicht um kumulierte Werte. Die Monats- und Jahresansicht zeigen hingegen die " +
      "kumulierten Werte für alle Tage eines Monats bzw. alle Monate eines Jahres.",
  },
  {
    type: "text",
    content:
      "In der Flusshistorie sind (je nach gewähltem Zeitintervall) bis zu vier verschiedene Graphen zu sehen:",
  },
  {
    type: "subsubtitle",
    content: "Leistungsflüsse",
  },
  {
    type: "text",
    content:
      "Dieser Graph umfasst alle gespeicherten Leistungflüsse: Die Einspeisung, den Netzbezug, die Batterieentladung, " +
      "die Erzeugung sowie die Last.",
  },
  {
    type: "subsubtitle",
    content: "Nutzung der Erzeugung",
  },
  {
    type: "text",
    content:
      "Hier sehen Sie, wie viel der Erzeugung wofür genutzt wurde: Zur direkten Nutzung, zur Batterieaufladung sowie " +
      "zur Einspeisung in das Netz.",
  },
  {
    type: "subsubtitle",
    content: "Deckung des Verbrauchs",
  },
  {
    type: "text",
    content:
      "In diesem Graph wird gezeigt, wodurch Ihr Verbrauch zu welchen Teilen gedeckt wurde: Aus dem Netz, aus eigener " +
      "Erzeugung sowie aus dem Batteriebezug.",
  },
  {
    type: "subsubtitle",
    content: "Batterie-Ladezustand",
  },
  {
    type: "text",
    content:
      "Dieser Graph zeigt den Ladezustand der Batterie und gibt dabei Lade- und Entladevorgänge an.",
  },
];

export const flowHistoryDataExportTexts = [
  {
    type: "subsubtitle",
    content: "Datenexport",
  },
  {
    type: "text",
    content:
      "Unten auf der Seite der Flusshistorie können Sie die Daten für verschiedene Zeitintervalle als Excel-Datei " +
      "herunterladen.",
  },
];

export const wallboxHeader = "Wallbox";

export const wallboxStateTexts = [
  {
    type: "text",
    content:
      "Über die Energieimpuls-App können Sie Ihre Wallbox steuern. " +
      "Es wird Ihnen der Status Ihrer Wallbox angezeigt und bei einem " +
      "Ladevorgang der aktuelle Ladestrom abgebildet. " +
      "In Abhängigkeit Ihres Wallbox-Modells wird der tatsächliche oder aber " +
      "der von der Wallbox zur Verfügung gestellte Strom angezeigt. " +
      "Des Weiteren können Sie durch das Klicken auf das Schlosssymbol " +
      "Ihre Wallbox sperren bzw. entsperren. Sie können die Wallbox " +
      "dauerhaft entsperrt lassen (z. B. wenn diese sich in Ihrer Garage " +
      "befindet) oder nach dem Ladevorgang sperren, um zu verhindern, dass " +
      "Unbefugte Ihre Wallbox nutzen.",
  },
];

export const wallboxModeTexts = [
  {
    type: "text",
    content:
      "Für ein optimiertes Laden, können sie darüber hinaus den Lademodus " +
      "der Wallbox steuern. Beim Schnellladen wird Ihr Fahrzeug mit dem " +
      "maximalen Ladestrom geladen, um die Batterie Ihres Fahrzeugs möglichst " +
      "schnell zu füllen. Möchten Sie hingegen lediglich die erzeugte Energie " +
      "Ihrer PV-Anlage zur Ladung nutzen, um Ihre erzeugte Energie möglichst " +
      "optimal zu nutzen, können Sie das PV-Überschussladen aktivieren. " +
      "Das Fahrzeug wird dann lediglich mit Überschusss aus Ihrer PV-Anlage " +
      "geladen. Die Wallbox beginnt das Fahrzeug zu laden, sobald Ihr Überschuss " +
      "die minimale Ladeenergie der Wallbox übersteigt. Die Ladeenergie wird " +
      "fortlaufend an Ihren PV-Überschuss angepasst. Jedoch kann eine Ladung mit " +
      "diesem Lademodus in Abhängig von der Produktion Ihrer PV-Anlage sehr " +
      "lange dauern. Für eine effiziente Nutzung der Energie bei gleichzeitiger " +
      "Sicherstellung einer ausreichenden Ladung Ihres Fahrzeugs, kann das " +
      "PV-Hybridladen aktvierit werden. Beim PV-Hybridladen können Sie den " +
      "minimalen Ladestrom wählen, mit dem Ihr Fahrzeug geladen wird, auch wenn " +
      "kein oder lediglich geringer PV-Überschuss vorhanden ist. ",
  },
];

export const wallboxSchedulingTexts = [
  {
    type: "text",
    content:
      "Möchten Sie Ihr Fahrzeug zu festgelegten Zeiten laden, können Sie Ladevorgänge planen. " +
      "Dies erfolgt über die Einstellung von Zeiten für das Sperren bzw. Entsperren Ihrer Wallbox. " +
      "Ist z.B. eine Ladung erst zu einem späteren Zeitpunkt gewünscht, kann das Fahrzeug bereits " +
      "an die Wallbox angeschlossn und diese gesperrt werden. Durch die Einstellung einer " +
      "Entsperrzeit kann sichergesetllt werden, dass die Wallbox zu einem von Ihnen gewünschten " +
      "Zeitpunkt entsperrt und Ihr Fahrzeug geladen wird. ",
  },
];

export const wallboxHistoryTexts = [
  {
    type: "text",
    content:
      "Weiterhin werden Ihnen vergangene Ladevorgänge angzeigt. " +
      chargingAmountWarning,
  },
];

export const heatpumpHeader = "Wärmepumpe";

export const heatpumpStateTexts = [
  {
    type: "text",
    content:
      "Ihre Wärmepumpe ist SG-Ready-fähig. Dies bedeutet, dass die Soll-Temperatur erhöht werden kann, wenn viel " +
      "Sonnenenergie verfügbar ist. Zur Schonung Ihrer Wärmepumpe sollte dies jedoch nicht beliebig oft erfolgen. " +
      "Die Steuerung der Wärmepumpe übernimmt das System für Sie basierend auf Wetter- und Lastvorhersagen. Daher " +
      "sehen Sie hier lediglich den Status, können Ihn aber nicht manuell ändern. Bitte beachten Sie, dass es ein " +
      "paar Tage dauern kann, bis die Soll-Temperatur der Wärmepumpe das erste Mal bei hoher PV-Erzeugung erhöht " +
      "wird, da zunächst ein Kalibiervorgang für die Schätzung der Verbrauchswerte läuft.",
  },
];

export const heatpumpSgReadySettingsTexts = [
  {
    type: "text",
    content:
      "Weiterhin können die " +
      "Zeiten eingeschränkt werden, in denen SG-Ready eingeschaltet wird, falls Sie dies wünschen. Stellen Sie " +
      "bspw. die früheste Anschaltzeit auf 9 Uhr und die späteste Anschaltzeit auf 18 Uhr, wird SG-Ready nicht " +
      "vor 9 bzw. nach 18 Uhr eingeschaltet. Beachten Sie hier, dass es sich lediglich um eine Einschränkung der " +
      "Einschaltzeiten handelt. Wird SG-Ready um 17 Uhr eingeschaltet, kann es (bei entsprechender Erzeugungs- und " +
      "Verbrauchsprognose) sein, dass es bis 19 Uhr eingeschaltet bleibt.",
  },
  {
    type: "text",
    content:
      "Zudem kann der minimale Ladezustand der Batterie eingestellt werden. Dieser schränkt die Anschaltzeit " +
      "dahingehend ein, dass die Batterie mindestens den angegebenen Ladezustand aufweisen muss, damit SG-Ready " +
      "eingeschaltet wird. Beachten Sie hier, dass es sich lediglich um die Einschränkung der Einschaltung handelt. " +
      "Unterschreitet die Batterie den angegeben Ladezustand, wird SG-Ready nicht ausgeschaltet. Die Einstellung " +
      "eines minimalen Batterieladezustands dient einer Priorisierung der Batterieladung: SG-Ready wird erst " +
      "geschaltet, falls die Batterie ausreichend geladen ist.",
    condition: (context) =>
      context?.location?.inverter_set?.some((i) => i.battery_capacity),
  },
];

export const heatpumpHistoryTexts = [
  {
    type: "text",
    content: "Weiterhin sind die vergangenen Schaltvorgänge aufgelistet. ",
  },
];

export const chargingHistoryHeader = "Ladehistorie";

export const chargingHistoryTexts = [
  {
    type: "text",
    content:
      "In der Ladehistorie können Sie die Ladevorgänge Ihres E-Autos einsehen sowie die Daten als Excel-Datei " +
      "exportieren. " +
      chargingAmountWarning,
  },
];

export const sgReadyHistoryHeader = "Wärmepumpe";

export const sgReadyTexts = [
  {
    type: "text",
    content:
      "Auf dieser Seite sehen Sie, wann in der Vergangenheit der PV-Einschaltbefehl für Ihre Wärmepumpe aktiv war, " +
      "d.h. zu welchem Zeitpunkt die Soll-Termperatur bei viel verfügbarer Sonnenenergie erhöht wurde. Die Steuerung " +
      "der Soll-Temperatur beruht auf der Vorhersage Ihrer Erzeugung sowie vergangenen Verbrauchswerten, die genutzt " +
      "werden, um einen Überschuss vorherzusagen. Ist der vorhergesagte Überschuss über einen gewissen Zeitraum hoch " +
      "genug, wird der PV-Einschaltbefehl aktiviert. Für eine optimale Steuerung Ihrere Wärmepumpe bleibt SG-Ready " +
      "nur über einen gewissen Zeitraum aktiv und wird auch nicht mehrmals am Tag aktiviert. Zudem wird der " +
      "PV-Einschaltbefehl deaktiviert, wenn bspw. aufgrund zu geringer Erzeugung oder ungewöhnlich hohen Verbrauches " +
      "entgegen der Vorhersage nicht genug Überschuss vorhanden ist.",
  },
];
